import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import PrimaryButton from "../components/PrimaryButton";
import user from "../assets/images/user.png";
import insta from "../assets/icons/insta.svg";
import ScheduledPostCard from "../components/ScheduledPostCard";
import { BiLinkAlt } from "react-icons/bi";
import DotMenu from "../components/DotMenu";
import { PiTrashLight } from "react-icons/pi";
import { MdOutlineSyncAlt } from "react-icons/md";
import { CgSync } from "react-icons/cg";
import PostedCard from "../components/PostedCard";
import MainModal from "../components/MainModal";
import SyncContent from "../components/SyncContent";
import { useLocation } from "react-router-dom";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import { CardSkeletonLoader } from "../components/CardSkeletonLoader";

const Schedules = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 500);
  }, []);
  return (
    <div className="mt-5">
      <p className="text-[#9392A2] text-xs font-medium">3 upcoming posts</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
          [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
          [...Array(6)].map((_, index) => <ScheduledPostCard key={index} />)
        }
      </div>
    </div>
  );
}

const Posted = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 500);
  }, []);
  return (
    <div className="mt-5">
      <p className="text-[#9392A2] text-xs font-medium">3 posts</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
          [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
          [...Array(6)].map((_, index) => <PostedCard key={index} />)
        }
      </div>
    </div>
  );
}

const About = () => {
  return (
    <div className="mt-5">
      <div className="mt-6 flex gap-2 flex-wrap">
        <div className="w-[379px]">
          <p className="text-[#9392A2] text-xs font-medium mb-3">Description</p>
          <div className="bg-white rounded-xl p-4">
            <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Hey there! I'm Andrew Wack, and I'm all about living life to the fullest! Currently based in New York, I'm a tech enthusiast, digital nomad, and avid explorer.</p>
            <PrimaryButton label="Edit description" black className="rounded-full inline-block px-4 py-1.5 mt-3.5" labelStyle="text-sm font-medium" />
          </div>
        </div>
        <div className="w-[379px]">
          <p className="text-[#9392A2] text-xs font-medium mb-3">Links</p>
          <div className="bg-white rounded-xl p-4">
            <div className="flex items-center gap-1 mb-2">
              <BiLinkAlt className="text-[#9392A2]" />
              <p className="text-[#0F0C18] text-sm font-medium tracking-tight">andrewack.com</p>
            </div>
            <div className="flex items-center gap-1">
              <BiLinkAlt className="text-[#9392A2]" />
              <p className="text-[#0F0C18] text-sm font-medium tracking-tight">apple.com</p>
            </div>
          </div>
        </div>
        <div className="w-[379px]">
          <p className="text-[#9392A2] text-xs font-medium mb-3">General information</p>
          <div className="bg-white rounded-xl p-4">
            <div className="flex items-center justify-between mb-2">
              <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Date of group creation</p>
              <p className="text-[#9392A2] text-sm font-medium tracking-tight">24.09.2020</p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Location</p>
              <p className="text-[#9392A2] text-sm font-medium tracking-tight">New York, United States</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const options = [
  { label: 'Move to group', icon: MdOutlineSyncAlt },
  { label: 'Sync content', icon: CgSync },
  { label: 'Delete account', icon: PiTrashLight, color: "red" },
];

const SpecificAccount = () => {
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [showSeleted, setShowSeleted] = useState<string>("");
  const location = useLocation();
  const redirect = useRedirect();

  useEffect(() => {
    if (!location.hash) {
      redirect("#schedules");
    } else if (location.hash === "#schedules") {
      setPageIndex(1);
    } else if (location.hash === "#posted") {
      setPageIndex(2);
    } else if (location.hash === "#about") {
      setPageIndex(3);
    }
  }, [location.hash, redirect]);
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[7px]">
          <h1 onClick={() => redirect(pathnames.accounts)} className="text-[#9392A2] text-xs cursor-pointer font-medium tracking-tight">Accounts</h1>
          <IoIosArrowForward className="text-[#9392A2] text-base font-medium" />
          <h1 onClick={() => redirect(pathnames.accounts+pathnames.specificGroup)} className="text-[#9392A2] text-xs cursor-pointer font-medium tracking-tight">Andrew Wack</h1>
          <IoIosArrowForward className="text-[#9392A2] text-base font-medium" />
          <h1 className="text-[#9392A2] text-xs font-medium tracking-tight cursor-pointer">@andrew_wack</h1>
        </div>
        <div className="flex items-center gap-2">
          <PrimaryButton label="Schedule multipost" className="rounded-full px-4 py-1.5" labelStyle="text-sm font-medium" />
          <DotMenu options={options} setSelected={setShowSeleted} type="circle" />
        </div>
      </div>
      <div className="mt-3.5 flex items-center gap-3.5">
        <img src={user} className="w-14 h-14 rounded-full" alt="user" />
        <div>
          <h1 className="text-[#0F0C18] text-[27px] font-medium tracking-tight">@andrew_wack</h1>
          <h1 className="text-[#9392A2] text-xs font-medium">Andrew Wack</h1>
        </div>
      </div>
      <p className="text-[#9392A2] mt-8 text-xs font-medium tracking-tight">Statistics</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">Instagram</h1>
          <div className="flex items-center justify-between">
            <p className="text-[#9392A2] text-xs font-medium tracking-tight">Social network</p>
            <div className="flex items-center gap-1">
              <img src={insta} className="w-4 h-4 rounded-full" alt="social icon" />
            </div>
          </div>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">7,534</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Total followers</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">3</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts scheduled</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">32</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts published</p>
        </div>
      </div>
      <div className="mt-8">
        <div className="flex items-center gap-[21px]">
          <p onClick={() => {
            setPageIndex(1)
            redirect("#schedules")
          }} className={`${pageIndex === 1 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer select-none`}>Schedules</p>
          <p onClick={() => {
            setPageIndex(2)
            redirect("#posted")
          }} className={`${pageIndex === 2 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer select-none`}>Posted</p>
          <p onClick={() => {
            setPageIndex(3)
            redirect("#about")
          }} className={`${pageIndex === 3 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer select-none`}>About</p>
        </div>
        <div className="w-full h-[1px] bg-[#CDCCD7] -mt-[1.5px]" />
      </div>
      {
        pageIndex === 1 && <Schedules />
      }
      {
        pageIndex === 2 && <Posted />
      }
      {
        pageIndex === 3 && <About />
      }
      {
        showSeleted === options[1].label &&
        <MainModal
          label="Sync content"
          setShowOption={setShowSeleted}
        >
          <SyncContent />
        </MainModal>
      }
    </>
  );
};

export default SpecificAccount;